import {Location} from '@wix/wix-ui-icons-common'
import classNames from 'classnames'
import React from 'react'
import {Text} from 'wix-ui-tpa/cssVars'
import {useSettings} from '../../../../../../../../commons/hooks/use-settings'
import settingsParams from '../../../../../../settingsParams'
import c from '../../../../classnames.scss'
import {Tags} from '../../../../styled-components/tags'
import s from '../list.scss'
import {classes} from './description.st.css'
import {DescriptionProps} from './interfaces'

export const Description = ({name, stageName, tags, t}: DescriptionProps) => {
  const settings = useSettings()
  const scheduleTitleTag = settings.get(settingsParams.scheduleTitleTag) as string

  return (
    <div>
      <Text className={classes.title} tagName={scheduleTitleTag}>
        {name}
      </Text>
      {stageName ? (
        <div className={classNames(s.location, c.scheduleLocationFont, c.scheduleLocationColor)}>
          <Location role="img" aria-label={t('schedule_location_aria')} /> {stageName}
        </div>
      ) : null}
      {tags.length ? (
        <Tags
          className={s.tags}
          items={tags?.map(tag => ({
            title: tag,
            value: tag,
          }))}
        />
      ) : null}
    </div>
  )
}
